import * as React from "react";
import { Input } from "@/components/ui/input";

const formatThousands = (v) => {
  const digits = String(v ?? "").replace(/[^\d]/g, "");
  if (digits === "") return "";
  return Number(digits).toLocaleString("id-ID");
};

const MoneyInput = React.forwardRef(({ value, onChange, ...props }, ref) => {
  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^\d]/g, "");
    const normalized = raw === "" ? "" : String(Number(raw));
    onChange({ target: { value: normalized } });
  };
  return (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      value={formatThousands(value)}
      onChange={handleChange}
      {...props}
    />
  );
});
MoneyInput.displayName = "MoneyInput";

const PercentInput = React.forwardRef(({ value, onChange, ...props }, ref) => {
  const display = value === "" || value === null || value === undefined ? "" : String(Math.round(Number(value) * 10000) / 100);
  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^\d.,-]/g, "").replace(",", ".");
    if (raw === "") { onChange({ target: { value: "" } }); return; }
    const n = parseFloat(raw);
    if (isNaN(n)) return;
    onChange({ target: { value: n / 100 } });
  };
  return (
    <Input
      ref={ref}
      type="text"
      inputMode="decimal"
      value={display}
      onChange={handleChange}
      {...props}
    />
  );
});
PercentInput.displayName = "PercentInput";

export { MoneyInput, PercentInput };
